import * as Comp from "../../../common/CommonComponents";
import * as common from "../../../common/common";
import http from "../../../common/http-common";

import { useState } from "react";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";

const UserActivator = (props) => {
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  //#region Modal Show/Hide
  const hideModal = () => {
    props.onHide();
  };
  //#endregion

  //#region Confirm Update Status
  const confirmBtnOnClick = () => {
    UpdateUserStatus(props.editData);
  };

  const UpdateUserStatus = (_data) => {
    let functionName = "";

    try {
      functionName = props.page + UpdateUserStatus.name;

      props.onLoading(
        true,
        (_data.ACTIVE_STATUS === "Active" ? "Deactivating" : "Activating") +
          " user, please wait..."
      );
      props.onHide();
      const data = {
        USER_ID: _data.USER_ID,
        USER_SHORT_NAME: _data.USER_SHORT_NAME,
        ACTIVE_FLAG: _data.ACTIVE_STATUS === "Active" ? "N" : "Y",
        UPDATE_ID: userId,
      };
      const action = data.ACTIVE_FLAG === "Y" ? "activate" : "deactivate";

      http
        .put("api/users/UpdateUserStatus", data, { timeout: 5000 })
        .then((response) => {
          toast.success("User is successfully " + action + "d.");
          props.onReload();
        })
        .catch((err) => {
          toast.error("Failed to " + action + " user. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
        })
        .finally(() => {
          props.onLoading(false, "Loading...");
        });
    } catch (err) {
      props.onLoading(false, "Loading...");
      const action = _data.ACTIVE_FLAG === "Y" ? "deactivate" : "activate";
      toast.error("Failed to " + action + " user. Please try again.");
      common.c_LogWebError(props.page, functionName, err);
    }
  };
  //#endregion

  const message = (
    <>
      Confirm to{" "}
      {props.editData !== null && props.editData.ACTIVE_STATUS === "Active"
        ? "deactivate"
        : "activate"}
      ? <br /> Username:{" "}
      {<b> {props.editData !== null && props.editData.USER_SHORT_NAME}</b>}
    </>
  );

  return (
    <>
      <Comp.ConfirmModal
        show={props.showHide}
        confirm={true}
        onHide={hideModal}
        onConfirm={confirmBtnOnClick}
      >
        {message}
      </Comp.ConfirmModal>
    </>
  );
};

export default UserActivator;
